import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';

export const testFirestoreWrite = async () => {
  try {
    console.log('Testing Firestore write permissions...');
    
    // Try to write a simple test document
    const testDoc = {
      test: true,
      timestamp: new Date(),
      message: 'Testing Firestore write permissions'
    };
    
    console.log('Attempting to write test document...');
    const docRef = await addDoc(collection(db, 'backups'), testDoc);
    console.log('Success! Document written with ID:', docRef.id);
    
    return { success: true, docId: docRef.id };
  } catch (error) {
    console.error('Firestore write test failed:', error);
    return { success: false, error: error.message };
  }
};

export default testFirestoreWrite;










